class Payments {
  constructor({ online, card } = {}) {
    this.online = online;
    this.card = card;
  }
}

export default Payments;